import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import ProviderDashboard from './pages/ProviderDashboard';
import Schedule from './pages/Schedule';
import CalendarSchedule from './pages/CalendarSchedule';
import EditService from './pages/EditService';
import ServiceDetails from './pages/ServiceDetails';
import Services from './pages/Services';
import ProviderProvisioning from './pages/ProviderProvisioning';
import Workers from './pages/Workers';
import WorkerEdit from './pages/WorkerEdit';
import Login from './pages/Login';
import Help from './pages/Help';
import './App.css';

const canAccessUsersManagement = (roles = []) =>
  roles.some((role) => ['admin', 'kcs-super-user'].includes((role || '').toLowerCase()));

function ProtectedUsersRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user || !canAccessUsersManagement(user.userRoles || [])) {
    return <Navigate to="/provider/dashboard" replace />;
  }

  return <Workers />;
}

function ProtectedProviderProvisioningRoute() {
  const { user, loading } = useAuth();
  const isGlobalSuperUser = (user?.userRoles || []).some((role) => (role || '').toLowerCase() === 'kcs-super-user');

  if (loading) return <div className="loading">Loading...</div>;
  if (!user || !isGlobalSuperUser) return <Navigate to="/provider/dashboard" replace />;
  return <ProviderProvisioning />;
}

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/provider/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/provider/dashboard" element={<ProviderDashboard />} />
          <Route path="/provider/schedule" element={<Schedule />} />
          <Route path="/provider/calendar" element={<CalendarSchedule />} />
          <Route path="/provider/services" element={<Services />} />
          <Route path="/provider/services/:id/edit-service" element={<EditService />} />
          <Route path="/provider/services/:id/edit-job" element={<ServiceDetails />} />
          <Route path="/provider/customers/*" element={<Navigate to="/provider/dashboard" replace />} />
          <Route path="/provider/users" element={<ProtectedUsersRoute />} />
          <Route path="/provider/provisioning" element={<ProtectedProviderProvisioningRoute />} />
          <Route path="/provider/workers" element={<ProtectedUsersRoute />} />
          <Route path="/provider/workers/new" element={<WorkerEdit />} />
          <Route path="/provider/workers/me/edit" element={<WorkerEdit />} />
          <Route path="/provider/workers/:id/edit" element={<WorkerEdit />} />
          <Route path="/provider/users/:id/edit" element={<WorkerEdit />} />
          <Route path="/provider/todo" element={<div className="page-placeholder"><h1>To-Do</h1><p>Coming soon...</p></div>} />
          <Route path="/provider/settings" element={<div className="page-placeholder"><h1>Settings</h1><p>Coming soon...</p></div>} />
          <Route path="/provider/help" element={<Help />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
